// extracted by mini-css-extract-plugin
export var bundleItemsContainer = "bundleList-module--bundleItemsContainer--acvC9";
export var bundleWrap = "bundleList-module--bundleWrap--AWNHq";
export var closeIcon = "bundleList-module--closeIcon--Md1oe";
export var emptyBundle = "bundleList-module--emptyBundle--gE+kd";